import { gql } from '@apollo/client';
import { searchVehicleBySerialNumberQuery } from 'next-common';

export const searchVehicleBySerialNumberParsed = gql`
  ${searchVehicleBySerialNumberQuery}
`;
